module.exports = __webpack_public_path__ + "img/banner-one3.f31abf2d.png";